export function input(currentQuestion) {
    const validateEmail = (email) => {
        return String(email)
            .toLowerCase()
            .match(
                /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
            );
    };

    const requiredFields = currentQuestion.find('input[required],textarea[required]').filter(function () {
        const field = $(this);

        return field.is(':visible') || field.closest('.growtype-quiz-question-answer').hasClass('is-active');
    });

    requiredFields.removeClass('is-invalid');

    let isValid = true;
    requiredFields.each(function (index, element) {
        const value = String($(element).val() || '');
        const minimumLength = parseInt($(element).attr('minlength'), 10);

        if (
            (
                $(element).attr('min') !== undefined && parseInt($(element).val()) < parseInt($(element).attr('min'))
            )
            ||
            (
                $(element).attr('max') !== undefined && parseInt($(element).val()) > parseInt($(element).attr('max'))
            )
            ||
            (
                value.trim().length === 0
            )
            ||
            (
                Number.isFinite(minimumLength) && value.trim().length < minimumLength
            )
            ||
            (
                $(element).attr('type') === 'email' && !validateEmail($(element).val())
            )
        ) {
            $(element).addClass('is-invalid');
            isValid = false;
        }
    })

    return isValid;
}
